import { z } from 'zod';

export const schema = ({
  currentEntityId,
  currentEnterpriseRiskId,
  modalSubType,
  errorMessage,
}: {
  currentEntityId: null | string | undefined;
  currentEnterpriseRiskId: null | string | undefined;
  modalSubType: 'enterpriseRisk' | 'entity';
  errorMessage: string;
}) =>
  z
    .object({
      EntityId: z.string().uuid({ message: 'Entity is required' }),
      EnterpriseRiskId: z.string().nullish(),
    })
    .refine(
      (val) => {
        if (
          currentEntityId &&
          currentEnterpriseRiskId &&
          val.EntityId === currentEntityId &&
          val.EnterpriseRiskId === currentEnterpriseRiskId
        ) {
          return false;
        }

        return true;
      },
      {
        message: errorMessage,
        // Attach the error to a field that is visible in the active modal
        // variant — the entity variant doesn't render the enterprise risk
        // select.
        path: [modalSubType === 'entity' ? 'EntityId' : 'EnterpriseRiskId'],
      }
    );

export type SchemaFields = z.infer<ReturnType<typeof schema>>;
